import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PolicyCard } from "@/components/site/PolicyCard";
import { Seo } from "@/components/site/Seo";

const FILTERS = [
  ["tutte", "Tutte", () => true],
  ["economiche", "Sotto 15 €/mese", (p) => p.price < 15],
  ["rc", "Con RC danni a terzi", (p) => p.coverages["RC danni a terzi"]],
  ["franchigia", "Franchigia bassa (≤20 €)", (p) => p.franchigia <= 20],
];

export default function Confronta() {
  const [policies, setPolicies] = useState([]);
  const [f, setF] = useState("tutte");
  useEffect(() => { api.get("/public/policies").then((r) => setPolicies(r.data)).catch(() => {}); }, []);
  const fn = FILTERS.find((x) => x[0] === f)[2];
  const list = policies.filter(fn);

  return (
    <div className="mx-auto max-w-7xl px-4 lg:px-8 py-14" data-testid="confronta-page">
      <Seo title="Confronta le assicurazioni per cani e gatti | Polizzapet.it" description="Barkibu, Figo, Santévet, Dottorpet, ConTe: prezzi da, massimali, franchigie e coperture a confronto, spiegati come a un amico." />
      <p className="label-mono text-emerald-500 mb-3">Confronto onesto</p>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight max-w-3xl leading-[1.05]">Le polizze pet a confronto, spiegate come a un amico.</h1>
      <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">Abbiamo letto le condizioni di polizza al posto tuo. Qui trovi prezzi di partenza, massimali, franchigie e cosa è coperto davvero. Aggiorniamo i dati ogni mese.</p>
      <div className="flex flex-wrap gap-2 mt-8">
        {FILTERS.map(([k, l]) => <button key={k} onClick={() => setF(k)} data-testid={`confronta-filter-${k}`} className={`px-3.5 py-1.5 rounded-full text-sm border transition-colors ${f === k ? "border-emerald-500 bg-emerald-500/10 text-emerald-600" : "border-border hover:bg-muted"}`}>{l}</button>)}
      </div>
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3 mt-10" data-testid="confronta-grid">
        {list.map((p) => <PolicyCard key={p.key} p={p} />)}
      </div>
      {list.length === 0 && <p className="text-muted-foreground py-10">Nessuna polizza con questi filtri.</p>}
      <p className="text-sm text-muted-foreground mt-10 max-w-3xl surface p-5"><b className="text-foreground">Trasparenza:</b> i prezzi sono indicativi "a partire da" per un cane/gatto giovane e sano, e cambiano con età, razza e regione. Alcuni link sono di affiliazione: se sottoscrivi tramite noi riceviamo una commissione, tu non paghi nulla in più. Non siamo legati a nessuna compagnia.</p>
      <section className="section-dark rounded-3xl p-10 sm:p-14 mt-16 text-center">
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Non sai quale scegliere?</h2>
        <p className="text-muted-foreground mt-3 max-w-xl mx-auto">Normale: sono fatte per confondere. Raccontaci del tuo pet e ti diciamo noi quale ha senso, o se non ne serve nessuna.</p>
        <Link to="/consulenza" className="btn-primary mt-7" data-testid="confronta-cta-consulenza">Chiedi a noi, gratis</Link>
      </section>
    </div>
  );
}
